import { call, put } from 'redux-saga/effects';

import waiverAction from './waiver.types';

export function* HANDLE_STATE({ field, value }) {
    yield put({
        type: waiverAction.SET_STATE,
        payload: {
            [field]: value,
        },
    });
}

export function* SET_LOADING(loading = false) {
    yield call(HANDLE_STATE, { field: 'loading', value: loading });
}

export function* SET_LOADING_STATE(field, loading = false) {
    yield call(HANDLE_STATE, { field, value: loading });
}

export function* SET_ERROR() {
    yield call(SET_LOADING);
}

export function* SET_LOADING_WAIVER(loading = false) {
    yield call(HANDLE_STATE, { field: 'loadingWaiver', value: loading });
}

export function* SET_ERROR_WAIVER() {
    yield call(SET_LOADING_WAIVER);
}

export const doHandleState = (field, value) => ({
    type: waiverAction.HANDLE_STATE,
    field,
    value,
});

export const doSetData = (payload) => ({
    type: waiverAction.HANDLE_STATE,
    field: 'data',
    value: payload,
});

export const doWaiver = (payload) => ({
    type: waiverAction.WAIVER,
    payload,
});

export const doSubmission = (payload, navigate, onSuccess) => ({
    type: waiverAction.SUBMISSION,
    payload,
    navigate,
    onSuccess,
});

export const doCheckEmailOrPhone = (payload, navigate) => ({
    type: waiverAction.CHECK_PHONE_OR_EMAIL,
    payload,
    navigate,
});

export const doCheckEmail = (payload, navigate, onSuccess) => ({
    type: waiverAction.CHECK_EMAIL,
    payload,
    navigate,
    onSuccess,
});

export const doLogin = (payload, navigate, onLogin) => ({
    type: waiverAction.LOGIN,
    payload,
    navigate,
    onLogin,
});

export const doSignIn = (payload, navigate) => ({
    type: waiverAction.SIGN_IN,
    payload,
    navigate,
});

export const doSendOTP = (payload, navigate, onSended) => ({
    type: waiverAction.SEND_OTP,
    payload,
    navigate,
    onSended,
});

export const doVerifyOTP = (payload, navigate, onVerified) => ({
    type: waiverAction.VERIFY_OTP,
    payload,
    navigate,
    onVerified,
});

export const doSetPassword = (payload, navigate, onSuccess) => ({
    type: waiverAction.SET_PASSWORD,
    payload,
    navigate,
    onSuccess,
});

export const doAddMinor = (payload) => ({
    type: waiverAction.SET_MINOR,
    payload,
});

export const doDeleteMinor = (payload) => ({
    type: waiverAction.SET_MINOR,
    payload,
});

export const doUploadImage = (payload) => ({
    type: waiverAction.UPLOAD_IMAGE,
    payload,
});
export const doPaymentProcess = (payload, navigate) => ({
    type: waiverAction.PAYMENT_PROCESS,
    payload,
    navigate,
});

export const doForgotPassword = (payload, navigate, onSuccess) => ({
    type: waiverAction.FORGOT_PASSWORD,
    payload,
    navigate,
    onSuccess,
});

export const doGetOrderById = (payload) => ({
    type: waiverAction.GET_ORDER_BY_ID,
    payload,
});

export const doUpdateWaiver = (payload) => ({
    type: waiverAction.WAIVER_UPDATE,
    payload,
});

export const doUpdateWaiverPhone = (payload) => ({
    type: waiverAction.WAIVER_UPDATE_PHONE,
    payload,
});

export const doUpdateWaiverEmail = (payload) => ({
    type: waiverAction.WAIVER_UPDATE_EMAIL,
    payload,
});

export const doCreateWaiverChild = (payload, navigate) => ({
    type: waiverAction.WAIVER_CREATE_CHILD,
    payload,
    navigate,
});

export const doUpdateWaiverChild = (payload) => ({
    type: waiverAction.WAIVER_UPDATE_CHILD,
    payload,
});

export const doDeleteWaiverChild = (payload) => ({
    type: waiverAction.WAIVER_DELETE_CHILD,
    payload,
});
